import { Box, SxProps, Typography, useMediaQuery } from '@mui/material';
import {
  IStyles,
  IconWrapper,
  PrimaryButton,
  pxToRem,
  pxTovW,
  theme,
} from '@geneo2-web/shared-ui';
import { useGlobalContext } from '../../../../app/Context/GlobalContextProvider';

interface IProps {
  isOnline?: boolean;
  primaryButton?: {
    text: string;
    clickHandler: () => void;
  };
  secondaryButton?: {
    text: string;
    clickHandler: () => void;
  };
  rootStyles?: SxProps;
}
export const ConnectedClassStartBox = (props: IProps) => {
  const { isOnline, primaryButton, secondaryButton, rootStyles } = props;
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { isIpadOnly } = useGlobalContext();

  const styles: IStyles = {
    root: {
      border: '1px solid #007CDC',
      boxSizing: 'border-box',
      width: { xs: 'unset', md: '100%', lg: pxTovW(602) },
      paddingX: { xs: pxToRem(10), md: pxTovW(78) },
      paddingY: { xs: pxToRem(10), md: pxTovW(25) },
      backgroundColor: '#F5FAFF',
      borderRadius: { xs: pxToRem(10), md: pxTovW(15) },
      display: 'flex',
      flexDirection: { xs: secondaryButton ? 'column' : 'row', md: 'column' },
      gap: { xs: secondaryButton ? pxToRem(11) : pxToRem(28), md: pxTovW(32) },
      ...rootStyles,
    },
    headingBox: {
      display: 'flex',
      gap: { xs: pxToRem(20), md: pxTovW(7) },
      margin: 'auto',
    },
    buttonBox: {
      display: 'flex',
      flexDirection: { xs: 'row', md: 'column' },
      gap: { xs: pxToRem(10), md: pxTovW(20) },
      margin: { xs: 'auto', md: 'unset', lg: 'unset' },
      alignItems: 'center',
    },
    button: {
      width: { xs: pxToRem(86), md: '70%', lg: '100%' },
      paddingX: { xs: pxToRem(7), md: pxTovW(21) },
      height: { xs: pxToRem(33), md: pxTovW(60) },
      borderRadius: { xs: pxToRem(5), md: pxTovW(10) },
    },
  };

  return (
    <Box sx={styles.root}>
      <Box sx={styles.headingBox}>
        <IconWrapper
          name={isOnline ? 'wifi' : 'no_connection'}
          size={isMobile || isIpadOnly ? 'large' : 'md'}
          parentFolder="icons"
          type="png"
        />

        <Typography variant="h2">
          {isOnline ? 'Connected Class' : 'Not Connected'}
        </Typography>
      </Box>

      <Box sx={styles.buttonBox}>
        {primaryButton && (
          <PrimaryButton
            onClick={primaryButton.clickHandler}
            fullWidth
            sx={styles.button}
            disabled={!isOnline}
          >
            <Typography
              variant="bodyText"
              color="common.white"
              fontWeight="bold"
              sx={{ fontSize: { xs: pxToRem(11), md: pxTovW(21) } }}
            >
              {primaryButton.text}
            </Typography>
          </PrimaryButton>
        )}

        {secondaryButton && (
          <PrimaryButton
            onClick={secondaryButton.clickHandler}
            color="primary"
            sx={{
              ...styles.button,
              '&.Mui-disabled': { backgroundColor: '#8FB1FF' },
            }}
            disabled={!isOnline}
          >
            <Typography
              variant="bodyText"
              color="common.white"
              fontWeight="bold"
              sx={{ fontSize: { xs: pxToRem(11), md: pxTovW(21) } }}
            >
              {secondaryButton.text}
            </Typography>
          </PrimaryButton>
        )}
      </Box>
    </Box>
  );
};
